module.exports = __webpack_public_path__ + "static/media/GROW.3538f896.png";